import { useCallback } from 'react';

import { Button } from '@/components/atoms/Button';
import { useToast } from '@/context/toast';
import { useMessages } from '@/hooks/messages';

import { newAppVersionToastMessageDefinitions } from './messages';

let newVersionDeployedMessageShown = false;

export const useShowNewVersionDeployedOnce = () => {
  const toast = useToast();
  const messages = useMessages(newAppVersionToastMessageDefinitions);

  const showNewVersionDeployedMessage = useCallback(() => {
    if (newVersionDeployedMessageShown) {
      return;
    }

    const toastMessage = (
      <div className='flex flex-col'>
        <div>{messages.newVersionDeployed()}</div>
        <Button variant='warning' onClick={() => location.reload()}>
          {messages.reloadButton()}
        </Button>
      </div>
    );
    toast.showToast(toastMessage, 'warning', { autoClose: false });
    newVersionDeployedMessageShown = true;
  }, [toast, messages]);

  return { showNewVersionDeployedMessage };
};
